import { ReactNode } from 'react';

import { LocalizedText } from '@mews/framework';
import { TextKey } from '@mews-commander/enums';
import { Option } from '@mews-commander/legacy-data-structures';
import { SelectField } from '@mews-commander/legacy-form';
import { ReceiverSelectValues } from '../enums';

interface Props {
    name: string;
    label: ReactNode;
    required?: boolean;
}

const ReceiverSelectField: React.FC<Props> = ({ name, label, required = true }) => {
    const selectProps = {
        label,
        name,
        options: [
            Option({
                value: ReceiverSelectValues.CustomerEmail,
                label: <LocalizedText textKey={TextKey.CustomerEmail} />,
            }),
            Option({
                value: ReceiverSelectValues.CustomEmail,
                label: <LocalizedText textKey={TextKey.CustomEmail} />,
            }),
        ],
        required,
    };

    return <SelectField {...selectProps} />;
};

export default ReceiverSelectField;
